import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { useAuth } from '../context/AuthContext';
import { renderInlineBold } from '../lib/renderInlineBold';

const RulesPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [rulesText, setRulesText] = useState('');
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let active = true;
    async function loadRules() {
      try {
        const response = await fetch('/legacy/Rules.txt');
        if (!response.ok) throw new Error('Unable to load rules.');
        const text = await response.text();
        if (!active) return;
        setRulesText(text);
      } catch (_err) {
        if (!active) return;
        setLoadError('Rules are temporarily unavailable.');
      }
    }
    loadRules();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="page-shell">
      <TopBar chip="Rules">
        <Button variant="outline-secondary" size="sm" onClick={() => navigate(isAuthenticated ? '/lobby' : '/login')}>
          ← Back
        </Button>
      </TopBar>

      <section className="lobby-hero">
        <h1>How to Play</h1>
        <p>The official rules, as printed with the original 1890s set.</p>
      </section>

      <div className="surface-panel p-3 p-md-4">
        <h2 className="panel-title">
          Official Rules <small>Numerica</small>
        </h2>
        {loadError && <p className="mb-0 text-danger">{loadError}</p>}
        {!loadError && !rulesText && <p className="mb-0 muted-text">Loading rules…</p>}
        {rulesText && <div className="document-body">{renderInlineBold(rulesText)}</div>}
      </div>
    </div>
  );
};

export default RulesPage;
